import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const CancellationPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 bg-stone-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-green-900 mb-8">Cancellation Policy</h1>
          <div className="bg-white rounded-xl border border-stone-200 p-8 space-y-6 text-stone-700 leading-relaxed">

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Before Dispatch</h2>
              <p>Orders may be cancelled if they have not yet been processed or dispatched.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">After Dispatch</h2>
              <p>Once an order has been assigned for delivery:</p>
              <ul className="list-disc pl-6 space-y-1 mt-1">
                <li>Cancellation is not guaranteed</li>
                <li>A cancellation fee may apply</li>
                <li>Delivery fee may still be charged</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">How to Cancel</h2>
              <p>Customers must contact us immediately at:</p>
              <p className="mt-2">
                <a href="tel:+27615304587" className="text-green-700 font-semibold text-lg hover:underline">0615304587</a>
              </p>
            </section>

            <section className="pt-4 border-t border-stone-200">
              <p className="text-sm text-stone-500">Nark Online reserves the right to decline cancellations once fulfillment has begun.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CancellationPolicy;
